<template>
  <div>
    <div id="lContent">
      <div id="conList">
        <div id="wTable">
          <div id="tab1">党建工作</div>
          <div id="tab2">发布时间</div>
        </div>
        <router-link id="oneCon" v-for="(item, index) in tableData" :key="index" tag="div" :to="{path:'/informationsDetials/innerDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">
          <div id="navdht"><img src="../../assets/img/navdh.png"></div>
          <div>
            <div class="text">{{ item.title }}</div>
            <div><span>{{ item.createtime }}</span></div>
          </div>
        </router-link>
      </div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal.total" style="margin-top: 1em;text-align:right">
      </el-pagination>
    </div>
    <div id="mlContent">
      <div id="mconList">
        <div id="mwTable">
          <div id="mtab1">党建工作</div>
          <div id="mtab2">发布时间</div>
        </div>
        <router-link id="moneCon" v-for="(item, index) in mtableData" :key="index" tag="div" :to="{path:'/informationsDetials/innerDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">
          <div id="mnavdht"><img src="../../assets/img/navdh.png"></div>
          <div>
            <div class="text">{{ item.title }}</div>
            <div><span>{{ item.createtime }}</span></div>
          </div>
        </router-link>
      </div>
      <el-pagination background @size-change="mhandleSizeChange" @current-change="mhandleCurrentChange" :current-page="currentPage"
        :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal.total" style="margin-top: 1em;text-align:right">
      </el-pagination>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1,
        arrData: [],
        mtableData: [],
        marrData: []
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("mlContent").style.display = "block";
        document.getElementById("lContent").style.display = "none";
        this.mhandleSearch()
      } else {
        document.getElementById("lContent").style.display = "block";
        document.getElementById("mlContent").style.display = "none";
        this.handleSearch()
      };

    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.search();
      },
      mhandleSizeChange(val) {
        this.pageSize = val;
      },
      mhandleCurrentChange(val) {
        this.pageNum = val;
        this.msearch();
      },
      handleSearch() {
        let eWidth = document.body.clientWidth;
        document.getElementById("conList").style.width = eWidth * 0.72 + "px";
        document.getElementById("wTable").style.width = eWidth * 0.72 - 10 + "px";
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/found-party/foundAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.arrData = [];
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
          that.tableData.sort(function(a, b) {
            return a.createtime < b.createtime ? 1 : -1;
          });
        }).catch(function(error) {
          console.log(err);
        })
      },
      mhandleSearch() {
        this.msearch();
      },
      // 查询列表
      msearch: function() {
        let that = this;
        let url = this.HOST + '/api/v1/found-party/foundAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.mtableData = cData.data.list;
          that.mtableData.sort(function(a, b) {
            return a.createtime < b.createtime ? 1 : -1;
          });
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #lContent {
    display: none;
  }

  #wTable {
    height: 60px;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    margin-left: 10px;
  }

  #tab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 50px;
    font-weight: bold;
  }

  #tab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    right: 100px;
    font-weight: bold;
  }

  #navdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 20px;
    cursor: pointer;
  }

  #navdht>img {
    width: 100%;
    height: 100%;
  }

  #oneCon {
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    margin-left: 40px;
  }

  #oneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 50px;
  }

  #oneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 99px;
    cursor: pointer;
  }

  #oneCon>div>.text {
    cursor: pointer;
    width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-text-overflow:ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  #oneCon>div>.text:hover,
  #oneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }

  /*mobile*/
  #mconList {
    margin: auto 10px;
  }

  #mwTable {
    height: 60px;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
  }

  #mtab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 10%;
    font-weight: 500;
  }

  #mtab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 10%;
    font-weight: 500;
  }

  #mnavdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 30px;
    left: 20px;
    cursor: pointer;
  }

  #mnavdht>img {
    width: 100%;
    height: 100%;
  }

  #moneCon {
    height: 80px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
  }

  #moneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 25px;
    left: 50px;
  }

  #moneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 25px;
    right: 5%;
    cursor: pointer;
  }

  #moneCon>div>.text {
    cursor: pointer;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-text-overflow:ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  #moneCon>div>.text:hover,
  #moneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Informations/inner.vue